import { defineMessage } from 'services/localization';

export const messages = {
    description: defineMessage('check_available_balance_ected_on_the_batch_form'),
    confirmButton: defineMessage('confirm_payment'),
    currency: defineMessage('currency'),
    available: defineMessage('available'),
    toBePaid: defineMessage('to_be_paid'),
    noBalances: defineMessage('no_balances'),
    generalError: defineMessage('unable_to_retrieve_acco_ater_or_contact_support'),
};
